module.exports = __webpack_public_path__ + "static/media/hospital.0317b399.svg";